module.exports = __webpack_public_path__ + "static/media/anage-select-banner-footer.1e524220.webp";